/**
 *@author shaolei
 *@date 2020/04/03
 *@file_name:developer
 *@Description:开发者帮助
 */
<template>
  <div class="developer">
    <div class="title">
      <div @click="toLink('/help/developer')" class="_p">开发者帮助</div>
      <div @click="toLink('/help/applyDevHelp')" class="apply">申请帮助</div>
    </div>
    <el-collapse class="customize-el-collapse" v-model="activeNames" @change="changeQa">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="title-diy">
            <div>什么是韵达开放平台？</div>
            <div class="status success">已处理</div>
          </div>
        </template>
        <div>韵达开放平台是服务于韵达快递合作伙伴的对接平台。主要为公司内部各部门和合作伙伴提供快递业务接入能力、快递查询能力，是韵达信息一体化、规范化必不可少的组成部分。平台以提高韵达业务体系的数据交互能力、提升韵达服务质量为使命，致力于拓宽韵达业务渠道、提升智能化和信息化水平。</div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="title-diy">
            <div>如何成为韵达开放平台用户？</div>
            <div class="status pending">待处理</div>
            <div class="opert">
              <el-popover placement="bottom" width="230" height="116" v-model="visible">
                <div class="content">
                  <p>
                    <img src="@/assets/images/icon-sss.png" alt="">您确定不需要继续协助？
                  </p>
                </div>
                <div class="btn_list">
                  <div @click="visible = false">再想想</div>
                  <div @click="visible = false" class="ok">确定</div>
                </div>
                <div slot="reference" @click.stop class="btn">取消</div>
              </el-popover>
              <div @click.stop="edit()" class="btn edit">修改</div>
            </div>
          </div>
        </template>
        <div :class="'pending_text'">等待处理中......</div>
      </el-collapse-item>
    </el-collapse>
    <div class="page">
      <el-pagination
        background=""
        @current-change="currentChange"
        :current-page="page"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getDevHelp } from "@/apis/help.js";
export default {
  name: "developer",
  data() {
    return {
      activeNames: ["1", "2", "3"],
      visible: false,
      pageSize: 5,
      page: 1,
      total: 0
    };
  },

  computed: {
    //计算属性
  },

  created() {
    //创建时执行
    this.getList()
  },

  mounted() {
    //数据挂载
  },

  methods: {
    //函数声明
    /** 获取帮助列表数据 */
    async getList() {
      let res = await getDevHelp(this).then(res => {
        console.log(res)
      })
    },
    changeQa() {},
    /** 取消 */
    cancel() {},
    /** 修改 */
    edit() {},
    /** 页面跳转 */
    toLink(path) {
      this.$router.push(path);
    },

    /** 分页 */
    currentChange() {}
  }
};
</script>
<style lang='less' scoped>
.developer {
  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;

    .apply {
      position: absolute;
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      cursor: pointer;
      padding: 5px 22px;
      font-size: 14px;
      color: #333333;
      border-radius: 2px;
      right: 0;
      background: #fabe00;
    }

    &::after {
      content: "";
      position: absolute;
      height: 1px;
      left: 0px;
      right: 0px;
      bottom: 0;
      background: #ebebec;
    }

    ._p {
      font-size: 16px;
      position: relative;
      cursor: pointer;

      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }
  }

  .customize-el-collapse {
    padding: 20px 0;
    border: none;
    min-height: 700px;

    .pending_text {
      font-size: 14px;
      color: #999999;
    }

    .title-diy {
      display: flex;
      position: relative;
      width: 100%;

      .status {
        margin-left: 22px;
        position: relative;

        &::after {
          content: "";
          height: 6px;
          width: 6px;
          border-radius: 100%;
          position: absolute;
          left: -15px;
          top: 50%;
          margin-top: -3px;
        }
      }

      .success {
        &::after {
          background: #32c862;
        }
      }
      .pending {
        &::after {
          background: #fa9e00;
        }
      }

      .opert {
        position: absolute;
        z-index: 9;
        right: 20px;
        display: flex;
        top: 50%;
        margin-top: -13px;

        .btn {
          border-radius: 2px;
          background: #ebebec;
          font-size: 12px;
          height: 26px;
          width: 52px;
          line-height: 26px;
          text-align: center;
          margin: 0 5px;
          -moz-user-select: none; /*火狐*/
          -webkit-user-select: none; /*webkit浏览器*/
          -ms-user-select: none; /*IE10*/
          -khtml-user-select: none; /*早期浏览器*/
          user-select: none;
          color: #999999;
        }

        .edit {
          color: #333333;
        }
      }
    }

    /deep/.el-collapse-item {
      border: 1px solid #ebeae8;
      margin-bottom: 30px;

      /deep/.el-collapse-item__header {
        background: #fafafa;
        padding: 0 10px 0 20px;
        border-bottom: none;
        color: #333333;
        font-weight: 500;
      }

      /deep/.el-collapse-item__wrap {
        border-bottom: none;

        /deep/.el-collapse-item__content {
          padding: 30px 20px;
          line-height: 28px;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }

    /deep/.is-active {
      /deep/.el-collapse-item__header {
        border-bottom: 1px solid #ebeae8;
      }
    }
  }
  .page {
    padding: 25px 0;
    display: flex;
    justify-content: center;

    /deep/.el-pagination__total {
      line-height: 30px;
      padding-left: 15px;
    }

    /deep/.el-pager {
      /deep/li {
        background: #fff;
        border: 1px solid #ebebec;
        line-height: 28px;
        font-weight: normal;
      }
      /deep/.active {
        background-color: #fabe00 !important;
        border-color: #fabe00;
      }
    }
    /deep/.btn-prev,
    /deep/.btn-next {
      background: #fff;
      border: 1px solid #ebebec;
    }
  }
}
.content {
  text-align: center;
  padding: 30px 25px;
  img {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 5px;
  }
}
.btn_list {
  margin: 0;
  display: flex;
  justify-content: center;

  div {
    height: 26px;
    width: 52px;
    background: #ebebec;
    font-size: 12px;
    color: #333333;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    line-height: 26px;
    text-align: center;
    margin: 5px;
    cursor: pointer;
  }
  .ok {
    background: #fabe00;
  }
}
</style>